import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${(props) => props.theme.white};
  height: 100vh;
  /* padding: 75px 20px 0 250px; */
  overflow: auto;
`;

export const TopSection = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: flex-start;
`;

export const ListContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;

  .ant-list {
    padding: 0;

    .ant-list-item {
      border-bottom: 1px solid #f0f0f0;
      padding: 0;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .ant-empty {
    padding: 48px 24px;
  }
`;

export const IssueCard = styled.div`
  width: 100%;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #fafafa;
  }

  .issue-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-right: 16px;

    .issue-description {
      font-size: 16px;
      line-height: 1.5;
      color: #262626;
      word-break: break-word;
    }

    .issue-date {
      font-size: 12px;
      color: #8c8c8c;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;

    .issue-content {
      margin-right: 0;
    }
  }
`;

export const IssueActions = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  .ant-space {
    .ant-btn {
      height: 32px;
      border-radius: 6px;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
      }
    }
  }

  @media (max-width: 768px) {
    justify-content: flex-end;
  }
`;
